/**
 * Which playback path a browser can actually use.
 *
 * Kept separate from the player so it stays pure and testable: it touches no
 * DOM beyond a feature check, and the player is full of both.
 */

export type SourceChoice = 'hls.js' | 'native' | 'mp4';

/** True when Media Source Extensions are usable — the real test for hls.js. */
export function hasMediaSource(): boolean {
  const ms = (globalThis as { MediaSource?: { isTypeSupported?: unknown } }).MediaSource;
  return !!ms && typeof ms.isTypeSupported === 'function';
}

/**
 * Pick the playback path.
 *
 * MSE wins whenever it is available. Chrome answers a truthy "maybe" to
 * `canPlayType('application/vnd.apple.mpegurl')` and then cannot play HLS at
 * all — trusting that check first leaves the video stalled at readyState 0 with
 * no error raised. Only a browser without MSE (iOS Safari) takes the native
 * path, which is also the one case where skipping the library is worthwhile.
 */
export function chooseSource(env: { hasMse: boolean; nativeHls: boolean }): SourceChoice {
  if (env.hasMse) return 'hls.js';
  if (env.nativeHls) return 'native';
  return 'mp4';
}
